import { User } from "src/app/model";
import { SystemType } from "src/app/model/enums/system.type";
import { IssueStage } from "./enums/issue.stage";
import { IssueType } from "./enums/issue.type";

export class ReportedIssue {
  ID: string;
  CONTACT_INFO: string;
  ISSUE_TYPE: IssueType
  DESCRIPTION: string;
  SUBJECT: string;
  CREATED_BY : User;
  CREATED_DATE:Date;
  STAGE : IssueStage;
  JIRA_KEY : string;
  TYPE : SystemType

  constructor(value: any = {}) {
    

    Object.assign(this, value);

    if(value.CREATED_BY)
      this.CREATED_BY = User.parse(value.CREATED_BY);
  }

  static parseArray(json: any[]): ReportedIssue[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(ReportedIssue.parse(j));

    return arr;
  }

  static parse(json: any): ReportedIssue {
    if (json) {
      const r = new ReportedIssue();
      r.ID = json.ID;
      r.CONTACT_INFO = json.CONTACT_INFO;
      r.ISSUE_TYPE = json.ISSUE_TYPE;
      r.DESCRIPTION = json.DESCRIPTION;
      r.SUBJECT = json.SUBJECT;
      r.CREATED_DATE = json.CREATED_DATE;
      r.CREATED_BY = User.parse(json.CREATED_BY);
      r.STAGE = json.STAGE;
      r.JIRA_KEY = json.JIRA_KEY;
      r.TYPE = json.TYPE
      return r;
    }
  }
}


